import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { SCRAPING_DATA_REVIEW_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearScrapingDataReviewSignals } from "./@signals"
import { useScrapingDataReview } from "./@hooks"
import ScrapingDataReviewFilters from "./Filters"
import ScrapingDataReviewTable from "./Table"
import ScrapingDataReviewDetailsDrawer from "./DetailsDrawer"
import ScrapingDataReviewImageViewer from "./ImageViewer"


export default function ScrapingDataReviewPage() {
    useScrapingDataReview()

    useEffect(() => {
        return clearScrapingDataReviewSignals
    }, [])

    return <PageWrapper
        head={SCRAPING_DATA_REVIEW_ROUTES.TITLE}
        title={SCRAPING_DATA_REVIEW_ROUTES.TITLE}
        subtitle={SCRAPING_DATA_REVIEW_ROUTES.SUBTITLE}
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ScrapingDataReviewFilters />
            </Grid>

            <Grid item xs={12}>
                {/* No coverage panel: the percentages live in the column labels
                    and in the column chooser, next to the field each one is
                    about. See Table/columns.jsx. */}
                <ScrapingDataReviewTable />
            </Grid>
        </Grid>

        <ScrapingDataReviewDetailsDrawer />
        <ScrapingDataReviewImageViewer />
    </PageWrapper>
}
